import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"{{this.CLASS_NAME}}__fill\" style={{this._fillStyle}}></div>\n",{ moduleName: "sh-www/components/progress-bar.hbs" })